import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { sendEmail } from './action';
import { emailValid, FormWrapperForm, LOGIN_INPUT_STYLE, LoginLanguagePicker, LoginLogo, LoginText, PageWrapper } from '../login/Login';
import { NoMarginH1 } from '../../authorization/users/Members';
import Input from '../../../components_v2/input/Input';
import { DefaultButton } from '../../../styles/global/css/GlobalButton';
import { ButtonStyle } from '../../../components_v2/popup/PopupCreation';
import { PrimaryColor } from '../../../styles/global/css/Utils';

export default function Forgot() {
	const [email, setEmail] = React.useState<string>('');
	const [sent, setSent] = React.useState<boolean>(false);
	const disabled = !email || emailValid(email) !== undefined;

	function onSubmit(e: React.FormEvent) {
		e.preventDefault();
		if (disabled) return;
		sendEmail(email).catch(console.error);
		setSent(true);
	}

	return <PageWrapper>
		<FormWrapperForm onSubmit={onSubmit}>
			<LoginLogo />
			{sent
				? <>
					<NoMarginH1><Translate id='login.meet_in_mail_box' /></NoMarginH1>
					<LoginText><Translate id='login.link_for_new_password' /></LoginText>
				</>
				: <>
					<NoMarginH1><Translate id='login.change_password' /></NoMarginH1>
					<LoginText><Translate id='login.forgot_your_password' /></LoginText>
					<Input
						name='email'
						type='email'
						label='Email'
						inputStyle={LOGIN_INPUT_STYLE}
						value={email}
						onChange={value => setEmail(value)}
					/>
					<DefaultButton
						buttonStyle={ButtonStyle.Primary}
						width='320px'
						height='40px'
						disabled={disabled}
					><Translate id='login.modify' /></DefaultButton>
				</>
			}
			<a href='/login' style={{ fontSize: '12px', color: PrimaryColor }}><Translate id='login.back_to_login' /></a>
		</FormWrapperForm>
		<LoginLanguagePicker />
	</PageWrapper>;
}
